/** `/app/clients/:userId/setup` — the configuration half of the client wizard.
 *
 *  Reached by `NewClientPage` after it creates the trainee, and from the client page's action menu
 *  as "השלמת הגדרות". Because the trainee id comes from the URL, every step below has a real id to
 *  write against and a refresh resumes where the coach left off. */

import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useParams } from "react-router-dom";
import { RTL } from "../cache/CacheRtl";
import ClientSetupWizard from "../componenets/client/setup/ClientSetupWizard";
import { getClient } from "../services/TraineeService";
import { t } from "../componenets/dashboard/coach/coachTokens";

interface LoadedClient {
  name?: string;
  gender?: "MALE" | "FEMALE";
}

const ClientSetupPage = () => {
  const { userId } = useParams();
  const traineeId = Number(userId);
  const [client, setClient] = useState<LoadedClient | null>(null);
  const [loading, setLoading] = useState(true);

  // One read, for the header name and to scope the workout-template list by gender the way
  // `ChnageProgramDialog` does. A failure is not fatal — the wizard works without either.
  useEffect(() => {
    if (!Number.isFinite(traineeId)) {
      setLoading(false);
      return;
    }
    let alive = true;
    getClient(traineeId)
      .then(res => {
        if (alive) setClient(res.data ?? null);
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [traineeId]);

  return (
    <RTL>
      <Box dir="rtl">
        {loading ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "80px 0",
              backgroundColor: t.bg,
            }}
          >
            <CircularProgress size={24} sx={{ color: t.green }} />
          </Box>
        ) : (
          <ClientSetupWizard
            mode="configure"
            traineeId={traineeId}
            traineeName={client?.name}
            traineeGender={client?.gender}
          />
        )}
      </Box>
    </RTL>
  );
};

export default ClientSetupPage;
